import {Component, ViewEncapsulation, inject} from '@angular/core';
import {FormButtonComponent} from "../../../shared/elements/form-button/form-button.component";
import {TooltipComponent} from "../../../shared/elements/tooltip/tooltip.component";
import {RouterService} from "../../../shared/services/router.service";
import {IconBarPolicy, IconBarService} from "../../../shared/services/icon-bar.service";
import {TranslatePipe} from "../../../shared/pipes/translate.pipe";
import {NavService} from "../../../shared/services/nav.service";
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-bar-icons',
    imports: [
        FormButtonComponent,
        TooltipComponent,
        TranslatePipe
    ],
    templateUrl: './bar-icons.component.html',
    styleUrl: './bar-icons.component.scss',
    encapsulation: ViewEncapsulation.None
})
export class BarIconsComponent {
  public routerService: RouterService = inject(RouterService);
  private barIconService: IconBarService = inject(IconBarService);
  public navService: NavService = inject(NavService);

  public iconBarVisible: boolean = false;
  public iconBarPolicy: IconBarPolicy = IconBarPolicy.Toggleable;

  public constructor() {
    this.barIconService.iconBarVisible
    .pipe(takeUntilDestroyed())
    .subscribe((value) => {
      this.iconBarVisible = value;
    });

    this.barIconService.iconBarPolicy
    .pipe(takeUntilDestroyed())
    .subscribe((value) => {
      this.iconBarPolicy = value;
    });
  }

  public get shouldShowIconBar(): boolean {
    return this.iconBarPolicy === IconBarPolicy.ForcedVisible || this.iconBarVisible;
  }

}
